import { downgradeInjectable } from '@angular/upgrade/static';
import { AlgoliaSchemasFacade, DataIndexSchemasFacade, SchemaBrowserFacade } from '@mode/queries/schemas/domain';
import * as angular from 'angular';
import { SchemaBrowserObservabilityService } from '@mode/shared/util-observability';
import { AiGatewayClientService } from '@mode/queries/ai-assist/domain';
import { AiGatewayAuthFacade } from '@mode/shared/authorization/domain';

export const DowngradedSchemasDomainModule = angular
  .module('downgraded-schemas-domain', [])
  .service('AlgoliaSchemasFacade', downgradeInjectable(AlgoliaSchemasFacade))
  .service('AlphabeticalSchemasFacade', downgradeInjectable(DataIndexSchemasFacade))
  .service('SchemaBrowserFacade', downgradeInjectable(SchemaBrowserFacade))
  .service('AiGatewayClientService', downgradeInjectable(AiGatewayClientService))
  .service('AiGatewayAuthFacade', downgradeInjectable(AiGatewayAuthFacade))
  .service('SchemaBrowserObservabilityService', downgradeInjectable(SchemaBrowserObservabilityService)).name;
